import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { creditValidityTypes } from 'actions/types'

const initialState = null
const baseType = creditValidityTypes.FETCH_CREDIT_VALIDITY

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
})

export default reducer
